// extracted by mini-css-extract-plugin
export default {"customer-organization-form__company-info__company-info-inputs-container":"CompanyInformation_customer-organization-form__company-info__company-info-inputs-container__e7CID"};